import styles from './ToggleSwitch.module.scss';

type ToggleSwitchProps = {
    checked: boolean;
    disabled?: boolean;
    onToggle: () => void;
};

export const ToggleSwitch = ({
    checked,
    disabled,
    onToggle,
}: ToggleSwitchProps) => {
    return (
        <label className={styles.toggleSwitch}>
            <input
                type="checkbox"
                checked={checked}
                onChange={onToggle}
                className={styles.toggleCheckbox}
                disabled={disabled}
            />
            <span className={styles.toggleSlider} />
        </label>
    );
};
